import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyD1F1VAjz5-8fEzG-KbYSlABlHvFx6lZGc",
  authDomain: "analog-decoder-441420-v6.firebaseapp.com",
  projectId: "analog-decoder-441420-v6",
  storageBucket: "analog-decoder-441420-v6.firebasestorage.app",
  messagingSenderId: "872048773597",
  appId: "1:872048773597:web:f55cf420273361db7e4e34"
};


const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const firestore = getFirestore(app);